import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { FilterIcon } from "@jti/brand-icons/filter";
import { NewFilterIcon } from "@jti/brand-icons/new-filter";
import { useTranslations } from "../../../../providers/useTranslations";
import { StoreLocatorLayoutSwitcher } from "../StoreLocatorLayoutSwitcher";
import styles from "./StoreLocatorFilterButton.module.scss";
export const StoreLocatorFilterButton = ({ onToggleFilters, isFiltersOpened, isFiltersAvailable, selectedFiltersNumber, className, }) => {
    const { __ } = useTranslations();
    if (!isFiltersAvailable) {
        return null;
    }
    return (_jsxs("button", { "data-testid": "storeLocatorFilterButton", className: classNames(styles.filtersButton, className, {
            [styles.filtersButtonActive]: isFiltersOpened,
            [styles.filtersButtonFilled]: selectedFiltersNumber,
        }), onClick: onToggleFilters, children: [_jsxs(StoreLocatorLayoutSwitcher, { layout: "v1", children: [_jsx(FilterIcon, { className: styles.filterIcon }), __("storelocator.filters"), " ", selectedFiltersNumber ? `(${selectedFiltersNumber})` : null] }), _jsxs(StoreLocatorLayoutSwitcher, { layout: "v2", children: [_jsx(NewFilterIcon, { className: styles.filterIcon }), selectedFiltersNumber > 0 && _jsx("div", { className: styles.filtersButtonNumber, children: selectedFiltersNumber })] })] }));
};
//# sourceMappingURL=StoreLocatorFilterButton.js.map